import axios from 'axios'
import store from '@/store'
import { getUrToken, getUxToken } from '@/utils/auth'

const reqeust = axios.create({
  baseURL: process.env.VUE_APP_REQUEST_URL,
  timeout: 1000 * 60 * 3,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})
reqeust.interceptors.request.use(config => {
  // 토큰 검사 필요
  if (store.getters.urtoken) {
    config.headers.uax = getUxToken()
    config.headers.urx = getUrToken()
  }
  return config
}, error => {
  Promise.reject(error)
})

reqeust.interceptors.response.use(response => {
  const res = response.data
  if (res.ruax) {
    store.dispatch('refreshUx', res.ruax).then(() => {
    })
  }

  /**
    * 20000 이면 정상 이며 나머지는 오류 코드임
    */
  if (res.rcode !== 20000) {
    if (res.rcode === 40444) {
      if (res.ruax) {
        store.dispatch('refreshUx', res.ruax).then(() => {
          console.log('사용자 정보가 변경되었습니다. 화면 새로고침 후 다시 이용하세요.')
          location.reload()
        })
      }
    }
    if (res.rcode === 413) {
      console.error(res.message)
      return response.data
    }
    // 30401 : 허가되지않은사용자
    if (res.rcode === 30401) {
      console.error(res.message)
    }

    if (res.rcode === 30999) {
      console.error(res.message)
    }

    // eslint-disable-next-line
      return Promise.reject(res.message)
  } else {
    return response.data
  }
}, error => {
  // 토큰만료 시 처리 하는 부분 필요
  Promise.reject(error)
})

export default reqeust
